<template>
  <q-card v-if="items && items.length>0">
    <q-card-section>
      <q-list>
        <draggable v-model="items" group="people" @start="startDrag" @end="endDrag">
          <q-item v-for="(item,index) in items" :key="index">
            <q-item-section side>
              <div class="text-grey-8">
                <q-btn size="12px" flat dense round icon="edit" color="indigo" @click="$emit('selected-row',item)"/>
                <q-btn size="12px" flat dense round icon="delete" color="red"
                       @click="deleteItem(index, item)"/>
              </div>
            </q-item-section>
            <q-item-section>
              <q-item-label class="q-mt-sm">
                {{ item.Title }}
                <q-chip v-if="item.AnswerType" color="grey-8" text-color="white"
                        :label="JSON.parse(item.AnswerType).Title" square/>
              </q-item-label>
            </q-item-section>
            <q-item-section side v-if="item && item.Answers!=='[]'">
              <div class="text-grey-8">
                <q-chip v-for="(record, index) in JSON.parse(item.Answers)" :key="index" :label="record"/>
              </div>
            </q-item-section>
          </q-item>
        </draggable>
      </q-list>
    </q-card-section>
  </q-card>

</template>

<script>
import {mapActions} from "vuex";
import draggable from 'vuedraggable'

export default {
  name: "QuestionsList",
  components: {draggable},
  props: {
    items: {
      type: []
    },
    questionInfo: {
      type: Object
    },
    questionTypes: [
      {ID: 1, Title: 'تشریحی'},
      {ID: 2, Title: 'تشریحی تک خطی'},
      {ID: 3, Title: 'چند گزینه ای'},
      {ID: 4, Title: 'تک گزینه ای'},
      {ID: 5, Title: 'بلی/خیر'},
      {ID: 6, Title: 'مقدار عددی'},
      {ID: 7, Title: 'تاریخ'},
    ]
  },
  data() {
    return {
      drag: false
    }
  },
  methods: {
    ...mapActions({
      crudQuestion: 'Questions/crudQuestions'
    }),
    deleteItem(index, row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'پرسش حذف شود؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.crudQuestion({
          action: 'delete',
          ID: row.ID
        }).then(() => {
          this.$delete(this.items, index)
          this.$q.notify({
            type: 'positive',
            position: 'top',
            icon: 'positive',
            message: 'پرسش حذف گردید'
          })
        })
      })
    },
    startDrag() {
      this.drag = true
    },
    endDrag() {
      this.drag = false
      this.items.forEach((record, index) => {
        record.Priority = index
      })
      this.crudQuestion({
        action: 'update-priority',
        items: this.items
      }).then(() => {
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>